<template>
    <div class="recycle_popup">
        <div class="mb-4 p-2 recycle_popup_action_container">
            <vs-row vs-type="flex" vs-align="end" vs-justify="between">
                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="p-2">
                        <div class="vs-input--label mb-1">Team</div>
                        <v-select
                            :options="teamOptions"
                            label="name"
                            :reduce="a => a.id"
                            v-model="filter.team_id"
                        ></v-select>
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="6"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="p-2">
                        <div class="vs-input--label mb-1">Advertiser</div>
                        <v-select
                            :options="advertiserOptions"
                            label="name"
                            :reduce="a => a.id"
                            v-model="filter.integration_id"
                        ></v-select>
                    </div>
                </vs-col>

                <vs-col
                  vs-w="12"
                  vs-sm="6"
                  vs-lg="3"
                  vs-xs="12"
                >
                  <div class="p-2">
                    <div class="vs-input--label mb-1">Country</div>
                    <v-select
                      :clearable="false"
                      :options="countriesOptions"
                      v-model="filter.country"
                      class="w-full"
                      label="iso_2"
                      :reduce="a => a.iso_2"
                    ></v-select>
                  </div>
                </vs-col>

                <vs-col
                  vs-w="12"
                  vs-sm="6"
                  vs-lg="3"
                  vs-xs="12"
                >
                  <div class="p-2">
                    <div class="vs-input--label mb-1">Language</div>
                    <v-select
                      :clearable="false"
                      :options="languagesOptions"
                      v-model="filter.language"
                      label="iso_2"
                      :reduce="a => a.iso_2"
                      class="w-full"
                    ></v-select>
                  </div>
                </vs-col>

                <vs-col
                  vs-w="12"
                  vs-sm="6"
                  vs-lg="3"
                  vs-xs="12"
                >
                  <div class="flex items-end">
                    <div class="p-2">
                      <vs-checkbox class="mb-2" :disabled="filter.count" v-model="filter.all">All</vs-checkbox>
                    </div>
                    <div class="p-2 flex items-end">
                      <vs-checkbox @input="countAction" :disabled="filter.all" v-model="filter.count" class="p-2"></vs-checkbox>

                      <div>
                        <div class="vs-input--label mb-1">Count</div>
                        <vs-input
                          :disabled="filter.all"
                          v-model="filter.count_input"
                          @input="item => filter.count = item !== ''"
                          class="inputx w-full"
                          @keypress="onKeypress($event)"
                        />
                      </div>
                    </div>
                  </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="3"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="p-2">
                        <div class="vs-input--label mb-1">Offset</div>
                        <vs-input
                            :disabled="filter.all"
                            v-model.number="filter.offset"
                            class="inputx w-full"
                            @keypress="onKeypress($event)"
                            @input="onKeypressInput(filter.offset, 'offset')"
                        />
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="3"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="p-2">
                        <div class="vs-input--label mb-1">Per time</div>
                        <vs-input
                            v-model.number="filter.leads_per_time"
                            class="inputx w-full"
                            @keypress="onKeypress($event)"
                            @input="onKeypressInput(filter.leads_per_time, 'leads_per_time')"
                        />
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="3"
                    vs-lg="3"
                    vs-xs="12"
                >
                    <div class="p-2">
                        <div class="vs-input--label mb-1">Timespan</div>
                        <v-select
                            :options="timespanOptions"
                            v-model="filter.leads_timespan_in_minutes"
                            class="w-full"
                        ></v-select>
                    </div>
                </vs-col>

                <vs-col
                    vs-w="12"
                    vs-sm="12"
                    vs-lg="12"
                    vs-xs="12"
                >
                    <div class="text-right p-2">
                        <vs-button
                            @click.prevent="submit"
                            color="primary"
                            type="filled"
                            :disabled="!!disableFilterBtn || loader"
                        >Submit</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </div>

        <ds-table
            ref="table"
            :data="data"
            :heads="heads"
            spacer
            ssr
            :view-items="[50, 100, 500]"
            :total="totalNum"
            :max-items="limitNum"
            :page="pageNum"
            select-key="id"
            select
            @page="page"
            @limit="limit"
            @sort="sort"
            @selected="selectedLead"
        >
            <template v-slot:person="{person}">
                <div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-user', 'fi-rr-user')"></vs-icon>
                        {{ person.first_name ? person.first_name : '-' }} {{ person.last_name ? person.last_name : '-' }}
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-mail', 'fi-rr-envelope')"></vs-icon>
                        {{ person.email ? person.email : '-' }}
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-smartphone', 'fi-rr-mobile-notch')"></vs-icon>
                        {{ person.phone ? person.phone : '-' }}
                    </div>
                </div>
            </template>

            <template v-slot:country="{country}">
                <div v-if="country.country && country.country !== undefined && country.country !== 'undefined'"
                     class="flex items-center">
                    <flag width="25" :iso="country.country" type="country"/>
                    <span class="pl-2">{{ country.country }}</span>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:team="{team}">
                <div class="flex items-center whitespace-no-wrap">
                    <vs-icon color="primary" v-bind="$iconData('icon-users', 'fi-rr-users')"></vs-icon>
                    <div class="ml-2 whitespace-no-wrap">{{ team.team ? (team.team.name || team.team.id) : '-' }}</div>
                </div>
            </template>

            <template v-slot:affiliate="{affiliate}">
                <div class="whitespace-no-wrap">{{ affiliate.user ? (affiliate.user.name) : '-' }}</div>
            </template>

            <template v-slot:advertiser="{advertiser}">
                <div class="whitespace-no-wrap">{{ advertiser.advertiser || advertiser.advertiser_id || '-' }} /
                    {{ advertiser.integration ? advertiser.integration.name : '-' }}
                </div>
            </template>

            <template v-slot:a_history="{a_history}">
                <div v-if="a_history.advertisers_history">
                    <div class="flex items-center" v-if="value" v-for="(value, key) in a_history.advertisers_history"
                         :key="key">
                        <vs-icon v-bind="$iconData('icon-alert-circle', 'fi-rr-circle-exclamation-check')" color="red"></vs-icon>
                        <div class="whitespace-no-wrap ml-2">{{ value }}</div>
                    </div>
                </div>
                <div v-else>-</div>
            </template>

            <template v-slot:created_at="{created_at}">
                <div v-if="!created_at.created_at">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="created_at.created_at">{{ created_at.created_at|date }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="created_at.created_at">{{ created_at.created_at|time }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:send_date="{send_date}">
                <div v-if="!send_date.send_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="send_date.send_date">{{ send_date.send_date|date }}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="send_date.send_date">{{ send_date.send_date|time }}</span>
                    </div>
                </div>
            </template>

            <template v-slot:first_action_date="{first_action_date}">
                <div v-if="!first_action_date.first_action_date">-</div>
                <div v-else>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-calendar', 'fi-rr-calendar-day')"></vs-icon>
                        <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|date}}</span>
                    </div>
                    <div class="whitespace-no-wrap flex items-center">
                        <vs-icon class="mr-1" color="primary" v-bind="$iconData('icon-clock', 'fi-rr-clock-three')"></vs-icon>
                        <span v-if="first_action_date.first_action_date">{{first_action_date.first_action_date|time}}</span>
                    </div>
                </div>
            </template>

            <template v-slot:landing="{landing}">
                {{ landing.landing_url ? landingUrl(landing.landing_url) : '-' }}
            </template>
        </ds-table>
    </div>
</template>

<script>
import vSelect from "vue-select";
import ErrorHandler from "@/utils/errorHandler";
import send from "@/utils/fetch";
import EventBus from "@/store/eventBus";
import {utils} from "@/utils/mixins";

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    mixins: [utils],

    data() {
        return {
            loader: false,
            disableFilterBtn: true,
            data: [],
            pageNum: 1,
            limitNum: 50,
            totalNum: 1,
            orderBy: {"name": "id", "direction": "desc"},
            filter: {
                all: false,
                count: false,
                count_input: '',
                integration_id: null,
                leads_per_time: '1',
                leads_timespan_in_minutes: 1,
                country: this.popupData.selected.country,
                language: this.popupData.selected.language,
                offset: 0,
                id: []
            },
            filters: {},
            heads: [
                {name: 'statistic_fields.id', key: 'id', sortKey: 'id', value: 'id', display: true},
                {name: 'global.Lead', key: 'person', sortKey: 'first_name', value: 'person', display: true},
                {name: 'global.Country', key: 'country', sortKey: 'country', value: 'country', display: true},
                {name: 'statistic.Lang', key: 'language', sortKey: 'language', value: 'language', display: true},
                {name: 'global.Offer', key: 'offer_name', sortKey: 'offer_name', value: 'offer_name', display: true},
                {name: 'global.Geo', key: 'geo', sortKey: 'geo',  value: 'geo', display: true},
                {name: 'global.Team', key: 'team', sortKey: 'team_name', value: 'team', display: true},
                {name: 'global.Affiliate', key: 'affiliate_hash', sortKey: 'affiliate_name', value: 'affiliate', display: true},
                {name: 'statistic.Reg_date', key: 'created_at', sortKey: 'created_at', value: 'created_at', display: true},
                {name: 'global.Send_date', key: 'send_date', sortKey: 'send_date', value: 'send_date', display: true},
                {name: 'global.Action_date', key: 'first_action_date', sortKey: 'first_action_date', value: 'first_action_date', display: true},
                {name: 'statistic.ADV_INT', key: 'advertiser_integration_id', sortKey: 'advertiser', value: 'advertiser', display: true},
                {name: 'global.ADV_history', key: 'advertisers_history', sortKey: 'advertisers_history', value: 'a_history', display: true},
                {name: 'statistic.ADV_Status', key: 'group_status', sortKey: 'group_status', value: 'group_status', display: true},
            ],
            advertiserOptions: [],
            teamOptions: [],
            countriesOptions: [],
            languagesOptions: [],
            timespanOptions: [1, 3, 5, 7, 10]
        }
    },

    components: {
        vSelect
    },

    watch: {
        'filter.id'(ids) {
            if (Array.isArray(ids) && ids.length > 0) {
                this.filter.all = true
                this.filter.count = false
                this.filter.count_input = ''
            }
        },
        'filter.all'(val) {
          if (!val) {
            this.$refs.table.clearSelect()
          }
        },
        'filter.team_id'(id) {
            if (id) {
                const team = this.teamOptions.find(item => item.id === id)
                if (team.affiliates && team.affiliates.length) {
                    this.filter.affiliate_id = team.affiliates[0].id
                } else {
                    this.filter.affiliate_id = null
                }
            } else {
                this.filter.affiliate_id = null
            }
        },
        'filter.country'(country) {
            this.filter.integration_id = null
            this.getIntegrations(
                country,
                this.filter.language,
                this.popupData.selected.offer
            )
        },
        'filter.language'(language) {
            this.filter.integration_id = null
            this.getIntegrations(
                this.filter.country,
                language,
                this.popupData.selected.offer
            )
        },

        filter: {
            handler(val) {
                if (
                    val.all &&
                    !val.count &&
                    val.integration_id &&
                    val.leads_per_time &&
                    val.leads_timespan_in_minutes &&
                    val.team_id &&
                    val.affiliate_id
                ) {
                    this.disableFilterBtn = false
                } else if (
                    !val.all &&
                    val.count &&
                    val.count_input !== '' &&
                    val.integration_id &&
                    val.leads_per_time &&
                    val.leads_timespan_in_minutes &&
                    val.team_id &&
                    val.affiliate_id
                ) {
                    this.disableFilterBtn = false
                } else {
                    this.disableFilterBtn = true
                }
            },
            deep: true
        }
    },

    methods: {
        selectedLead(ids) {
            this.filter.id = ids
        },

        countAction(item) {
            if (!item) {
                this.filter.count_input = ''
            }
        },

        async page(page) {
            if (this.pageNum !== page) {
                this.pageNum = page
                await this.get()
            }
        },

        async limit(limit) {
            if (limit !== this.limitNum) {
                this.limitNum = limit

                if (this.pageNum !== 1) {
                    await this.page(1)
                } else {
                    await this.get()
                }
            }
        },

        onKeypress(event, int = false) {
            const regex = int ? /^[0-9]$/ : /^[0-9.,]$/
            if (!regex.test(event.key)) {
                event.preventDefault()
            }
        },

        onKeypressInput(data, name) {
            if (name === 'offset') {
                if (typeof data !== "number" || !data) {
                    this.filter.offset = 0
                }
            }

            if (typeof data !== "number" || !data) {
                this.filter[name] = 0
            }
        },

        async sort(sort) {
            this.orderBy =  {
                name: sort.name,
                direction: sort.type
            }

            if (!sort.type) this.orderBy = {"name": "id", "direction": "desc"}

            await this.get()
        },

        async submit() {
            this.loader = true

            const filter = JSON.parse(JSON.stringify(this.filter))

            const data = {
                integration_id: filter.integration_id,
                limit: ~~filter.count_input,
                offset: filter.offset,
                all: filter.all,
                leads_per_time: ~~filter.leads_per_time,
                leads_timespan_in_minutes: ~~filter.leads_timespan_in_minutes,
                orderBy: JSON.stringify({"name": "id", "direction": "desc"}),
                team_id: filter.team_id,
                affiliate_id: filter.affiliate_id,
                country: filter.country,
                language: filter.language,
                filters: JSON.stringify({
                  id: filter.id
                })
            }

            if (this.filter.id && Array.isArray(this.filter.id) &&  !this.filter.id.length > 0) {
              delete data.filters
            }

            if (data.all) {
                delete data.offset
            }

            if (!filter.count) {
                delete data.limit
            }

            const params = {
                ...this.popupData.date,
                limit: this.limitNum,
                page: this.pageNum,
                orderBy: JSON.stringify(this.orderBy),
                filters: this.filters
            }

            try {
                await send(this.$url.recycle.leads, 'POST', {data, params})

                this.filter.offset += data.limit || 0

                this.$refs.table.clearSelect()

                EventBus.$emit('updateCount')
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                setTimeout(() => {
                    this.loader = false
                }, 700)
            }
        },

        createAdvOptions(data) {
            return data.map(item => ({
                name: `${item.advertiser.name || item.advertiser.id} / ${item.name}`,
                id: item.id
            }))
        },

        async getIntegrations(country, language, offer) {
            try {
                const response = await send(
                    this.$url.recycle.integrations,
                    'GET',
                    {
                        params: {
                            country,
                            language,
                            offer
                        }
                    }
                )
                    .then(response => response.data.result)

                this.advertiserOptions = this.createAdvOptions(response.integrations)
                this.teamOptions = this.createNameById(response.teams)
                this.countriesOptions = response.countries
                this.languagesOptions = response.languages

            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        async get() {
            try {
                const params = {
                    ...this.popupData.date,
                    limit: this.limitNum,
                    page: this.pageNum,
                    orderBy: JSON.stringify(this.orderBy),
                    filters: this.filters
                }

                this.data = await send(this.$url.recycle.leads, 'GET', {params})
                    .then(response => response.data.result.leads)
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loader = false
            }
        }
    },

    async mounted() {
        try {
            await this.getIntegrations(
                this.popupData.selected.country,
                this.popupData.selected.language,
                this.popupData.selected.offer
            )

            this.totalNum = this.popupData.total
            this.filters = this.popupData.filters

            await this.get()

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.recycle_popup {
    &_action_container {
        background: #f8f8f8;
        border-radius: 10px;
    }

    .vs-con-input {
        input {
            border: 1px solid rgba(0, 0, 0, 0.2) !important;
            box-shadow: none !important;
        }

        span {
            transform: translate(0) !important;
        }
    }

    .v-select {
        background: white;
    }
}
</style>
